import { render } from "./FooterSponsors.vue?vue&type=template&id=4c73c803&scoped=true"
import script from "./FooterSponsors.vue?vue&type=script&lang=js"
export * from "./FooterSponsors.vue?vue&type=script&lang=js"

import "./FooterSponsors.vue?vue&type=style&index=0&id=4c73c803&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c73c803"]])

export default __exports__